module.exports = __webpack_public_path__ + "img/dsci0064.23125732.jpg";